import { CSSProperties, FC } from 'react';
import { Typography } from 'antd';
interface FormLabelProps {
  label: string;
  required?: boolean;
  style?: CSSProperties;
}
const { Text } = Typography;
const FormLabel: FC<FormLabelProps> = ({ label, required = false, style }) => {
  return (
    <div
      className={`form-label-wrap ${required ? 'required' : ''}`}
      style={{ ...style }}
    >
      <Text type="secondary" style={{ fontSize: 12 }}>
        {label}
        {required && (
          <span
            style={{
              color: '#ff4d4f',
              marginLeft: '4px',
            }}
          >
            *
          </span>
        )}
      </Text>
    </div>
  );
};

export default FormLabel;
